module.exports = __webpack_public_path__ + "teg/media/lady.34b56944.png";